import { navData } from "../utils";

export const Nav = () => {
  return (
    <nav className="w-full h-full">
      <ul className="h-full flex flex-col justify-center items-center gap-y-6">
        {navData.map((nv) => (
          <li key={nv.href}>
            <a className="text-xl capitalize font-primary italic hover:text-dark transition-all duration-300" href={nv.href}>{nv.name}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
